/**
 * Task #6314 — client-side mirror of the backend "Car sold" reason matcher
 * (api-server lib/car-sold-auto-pause.ts). The backend auto-pauses the host's
 * listing when a cancel/decline carries the canonical "Car sold" reason
 * (task #6304); the cancel/decline forms use this to show an inline
 * "your listing will be paused" notice the moment the host picks it.
 *
 * Matching is by canonical row NAME, never id — dev/prod ids differ (the seed
 * migrations match by name for the same reason).
 */
const CAR_SOLD_NAME = "car sold";

export function isCarSoldReasonName(name: string | null | undefined): boolean {
  if (typeof name !== "string") return false;
  return name.trim().toLowerCase() === CAR_SOLD_NAME;
}
